module.exports = __webpack_public_path__ + "static/media/5DPO20.83547770.jpg";